import getConfig from 'next/config';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';
import {
  ARAB_COUNTRY_CODES,
  domainCode,
} from '../constants/staticPageConstants';
import { If } from './Atoms/Conditionals';

// Lazy load footer components to reduce main bundle size
const Footer = dynamic(() => import('./Footer'), { ssr: true });
const ARFooter = dynamic(
  () => import('./Footer/arFooter').then((mod) => ({ default: mod.ARFooter })),
  { ssr: true }
);
const FRFooter = dynamic(
  () =>
    import('./Footer/frCommonFooter').then((mod) => ({
      default: mod.FRFooter,
    })),
  { ssr: true }
);
const InternationalFooter = dynamic(
  () => import('./International/landing-pages/Footer'),
  { ssr: true }
);
const SGFooter = dynamic(
  () =>
    import('./Footer/sgCommonFooter').then((mod) => ({
      default: mod.SGFooter,
    })),
  { ssr: true }
);

const { publicRuntimeConfig } = getConfig();

type TPage = { props: Record<string, string> } & ReactNode;

type IMainProps = {
  children: TPage;
};

const resolveFooter = (pathname: string, domain: string): JSX.Element => {
  const domainCodeValue =
    Number(domain) || publicRuntimeConfig.BASE_URL.domainCode;

  if (ARAB_COUNTRY_CODES.includes(domainCodeValue)) {
    const language = pathname.includes(`/ar/`) ? 'Arabic' : 'English';
    return <ARFooter language={language} />;
  } else if (domainCodeValue === domainCode.ClearTech) {
    return <InternationalFooter />;
  } else if (domainCodeValue === domainCode.clearIn) {
    return <Footer backgroundColor="bg-black" />;
  } else if (
    [
      domainCode.cleartaxFR,
      domainCode.cleartaxES,
      domainCode.cleartaxMY,
      domainCode.cleartaxPL,
    ].includes(domainCodeValue)
  ) {
    return <FRFooter />;
  } else if ([domainCode.cleartaxSG].includes(domainCodeValue)) {
    return <SGFooter />;
  } else {
    return <Footer />;
  }
};

const HomePage = (props: IMainProps): JSX.Element => {
  const router = useRouter();
  const { children: page } = props;
  const showFooter = !page?.props?.hideFooter;
  return (
    <div data-testid="Homepage">
      {page}
      <If condition={showFooter}>
        {resolveFooter(router.pathname, router.query.domain as string)}
      </If>
    </div>
  );
};

export default HomePage;
